import { type Component, type JSX, Show } from 'solid-js'
import { A } from '@solidjs/router'
import { Trans } from '@mbarzda/solid-i18next'
import { Icon } from '@iconify-icon/solid'

export interface SidebarItemProps {
  readonly url: string
  readonly icon: JSX.Element
  readonly textKey: string
  readonly onItemSelected: () => void
  readonly comingSoon?: boolean
}

const SidebarItem: Component<SidebarItemProps> = (props) => {
  const isLinkActive = !props.comingSoon

  return (
    <li>
      <Show when={isLinkActive}>
        <A
          data-test-sidebar-link={props.textKey}
          onClick={props.onItemSelected}
          href={props.url}
          activeClass="bg-gray-50 text-primary-800"
          classList={{ 'opacity-50': !isLinkActive }}
          class="text-gray-700 hover:text-primary-800 hover:bg-gray-50 flex items-center rounded-md p-2 text-sm leading-6 font-semibold gap-3"
        >
          {props.icon}
          <Trans key={`ls_sidebar_${props.textKey}`} />
        </A>
      </Show>
      <Show when={!isLinkActive}>
        <div class="text-gray-400 flex items-center rounded-md p-2 text-sm leading-6 font-semibold justify-between gap-3">
          <div class="flex gap-2 opacity-60">
            <span>{props.icon}</span>
            <Trans key={`ls_sidebar_${props.textKey}`} />
          </div>
          <span class="opacity-60">
            <Icon icon="heroicons:information-circle-20-solid" class="text-[1rem]" />
          </span>
        </div>
      </Show>
    </li>
  )
}

export default SidebarItem
